export interface Article {
  id: string
  title: string
  excerpt: string
  category: string
  areaStudyId: number
  readTime: string
  date: string
  author: string
  slug: string
}

export const articles: Article[] = [
    {
    id: 'b1',
    title: 'Is an Online Business Degree Worth It in 2026?',
    excerpt:
      'We break down the ROI of earning a business degree online, including salary data, career outcomes, and what employers really think about online credentials.',
    category: 'Business & Finance',
    areaStudyId: 1,
    readTime: '7 min',
    date: 'Mar 15, 2026',
    author: 'Sarah Mitchell',
    slug: 'online-business-degree-worth-it'},
    {
    id: 'b2',
    title: 'Top 5 Specializations for Business Majors',
    excerpt:
      'From accounting to supply chain management, discover which business specializations offer the best job prospects and highest starting salaries.',
    category: 'Business & Finance',
    areaStudyId: 1,
    readTime: '5 min',
    date: 'Mar 10, 2026',
    author: 'James Park',
    slug: 'top-business-specializations'},
    {
    id: 'b3',
    title: 'How to Pay for Your Business Degree: Financial Aid Guide',
    excerpt:
      'A comprehensive guide to scholarships, grants, employer tuition reimbursement, and federal aid options for online business students.',
    category: 'Business & Finance',
    areaStudyId: 1,
    readTime: '8 min',
    date: 'Feb 28, 2026',
    author: 'Maria Gonzalez',
    slug: 'paying-for-business-degree'},
    {
    id: 'cj1',
    title: "Criminal Justice Careers: What Can You Do With a Bachelor's?",
    excerpt:
      'Explore the wide range of career paths available to criminal justice graduates, from law enforcement to federal agencies and private sector roles.',
    category: 'Criminal Justice & Legal Services',
    areaStudyId: 2,
    readTime: '6 min',
    date: 'Mar 12, 2026',
    author: 'David Chen',
    slug: 'criminal-justice-careers'},
    {
    id: 'cj2',
    title: 'Online vs. On-Campus Criminal Justice Programs',
    excerpt:
      'How do online criminal justice programs compare to traditional on-campus options? We examine curriculum, networking, and career outcomes.',
    category: 'Criminal Justice & Legal Services',
    areaStudyId: 2,
    readTime: '5 min',
    date: 'Mar 5, 2026',
    author: 'Lisa Thompson',
    slug: 'online-vs-campus-criminal-justice'},
    {
    id: 'p1',
    title: 'Psychology Degree Online: Your Complete 2026 Guide',
    excerpt:
      'Everything you need to know about earning a psychology degree online, including accreditation, licensure requirements, and program formats.',
    category: 'Psychology & Counseling',
    areaStudyId: 3,
    readTime: '9 min',
    date: 'Mar 14, 2026',
    author: 'Dr. Rachel Kim',
    slug: 'psychology-degree-online-guide'},
    {
    id: 'p2',
    title: 'Counseling vs. Clinical Psychology: Which Path Is Right for You?',
    excerpt:
      'Understanding the key differences between counseling and clinical psychology programs to help you choose the right career direction.',
    category: 'Psychology & Counseling',
    areaStudyId: 3,
    readTime: '6 min',
    date: 'Feb 20, 2026',
    author: 'Dr. Rachel Kim',
    slug: 'counseling-vs-clinical-psychology'},
    {
    id: 't1',
    title: 'Best Online Computer Science Degrees for Career Changers',
    excerpt:
      'Switching to tech? These online CS programs are designed for students without a technical background, with flexible schedules and strong career support.',
    category: 'Computers & IT',
    areaStudyId: 4,
    readTime: '7 min',
    date: 'Mar 18, 2026',
    author: 'Alex Rivera',
    slug: 'cs-degrees-career-changers'},
    {
    id: 't2',
    title: 'Cybersecurity vs. Software Engineering: Salary & Job Outlook',
    excerpt:
      "A data-driven comparison of two of tech's hottest fields, including median salaries, growth projections, and day-to-day responsibilities.",
    category: 'Computers & IT',
    areaStudyId: 4,
    readTime: '6 min',
    date: 'Mar 8, 2026',
    author: 'Alex Rivera',
    slug: 'cybersecurity-vs-software-engineering'},
    {
    id: 't3',
    title: 'Do You Need a Degree to Work in Tech?',
    excerpt:
      'Bootcamps, certifications, and self-teaching are popular alternatives. We examine when a formal degree still matters in the tech industry.',
    category: 'Computers & IT',
    areaStudyId: 4,
    readTime: '5 min',
    date: 'Feb 25, 2026',
    author: 'Priya Sharma',
    slug: 'degree-needed-for-tech'},
    {
    id: 'h1',
    title: 'Healthcare Administration: A Growing Field for Online Learners',
    excerpt:
      'With healthcare spending rising, administrators are in high demand. Learn how an online degree can launch your career in healthcare management.',
    category: 'Healthcare & Medical Assisting',
    areaStudyId: 5,
    readTime: '6 min',
    date: 'Mar 11, 2026',
    author: 'Nurse Kelly Adams',
    slug: 'healthcare-administration-online'},
    {
    id: 'h2',
    title: 'Medical Billing & Coding: Certificate vs. Degree',
    excerpt:
      'Should you pursue a certificate or a full degree in medical billing and coding? We compare costs, timelines, and earning potential.',
    category: 'Healthcare & Medical Assisting',
    areaStudyId: 5,
    readTime: '5 min',
    date: 'Feb 18, 2026',
    author: 'Nurse Kelly Adams',
    slug: 'medical-billing-certificate-vs-degree'},
    {
    id: 'e1',
    title: 'How to Become a Teacher With an Online Education Degree',
    excerpt:
      'A step-by-step guide to earning your teaching credential online, including student teaching requirements and state licensure information.',
    category: 'Education & Teaching',
    areaStudyId: 6,
    readTime: '8 min',
    date: 'Mar 13, 2026',
    author: 'Prof. Michael Torres',
    slug: 'become-teacher-online-degree'},
    {
    id: 'e2',
    title: 'Special Education Careers: High Demand, High Reward',
    excerpt:
      'Special education teachers are among the most in-demand educators. Discover what it takes and why this career path is so fulfilling.',
    category: 'Education & Teaching',
    areaStudyId: 6,
    readTime: '5 min',
    date: 'Feb 22, 2026',
    author: 'Prof. Michael Torres',
    slug: 'special-education-careers'},
    {
    id: 'n1',
    title: 'RN to BSN Online: Everything You Need to Know',
    excerpt:
      "Already a registered nurse? An online RN-to-BSN program can advance your career in as little as 12 months. Here's how to choose the right one.",
    category: 'Nursing',
    areaStudyId: 10,
    readTime: '7 min',
    date: 'Mar 16, 2026',
    author: 'BSN Jennifer Walsh',
    slug: 'rn-to-bsn-online-guide'},
    {
    id: 'n2',
    title: 'Nursing Scholarships & Financial Aid in 2026',
    excerpt:
      "Nurses have access to unique scholarship opportunities. We've compiled the top funding sources for aspiring and current nursing students.",
    category: 'Nursing',
    areaStudyId: 10,
    readTime: '6 min',
    date: 'Mar 1, 2026',
    author: 'BSN Jennifer Walsh',
    slug: 'nursing-scholarships-2026'},
    {
    id: 'tv1',
    title: 'Trade Schools vs. Traditional College: Which Path Pays Off?',
    excerpt:
      'Compare the costs, timelines, and earning potential of vocational training versus a four-year degree. The results may surprise you.',
    category: 'Trade, Vocational, Career',
    areaStudyId: 7,
    readTime: '7 min',
    date: 'Mar 9, 2026',
    author: 'Robert Martinez',
    slug: 'trade-school-vs-college'},
    {
            id: 'tv2',
            title: 'High-Paying Trade Careers That Don\'t Require a 4-Year Degree',
            excerpt: '',
            category: 'Trade, Vocational, Career',
            areaStudyId: 7,
            readTime: '6 min',
            date: 'Feb 27, 2026',
            author: 'Robert Martinez',
            slug: 'high-paying-trade-careers'
        },
    {
    id: 'tv3',
    title: 'How to Get Licensed: Trade Certification Requirements by State',
    excerpt:
      'Navigate the licensing landscape for skilled trades. We break down requirements, exam prep, and continuing education by profession and state.',
    category: 'Trade, Vocational, Career',
    areaStudyId: 7,
    readTime: '8 min',
    date: 'Feb 14, 2026',
    author: 'Robert Martinez',
    slug: 'trade-licensing-requirements'},
    {
    id: 'la1',
    title: 'What Can You Do With a Liberal Arts Degree?',
    excerpt:
      'Liberal arts majors are more employable than you think. Explore diverse career paths and why employers value these versatile graduates.',
    category: 'Liberal Arts',
    areaStudyId: 8,
    readTime: '7 min',
    date: 'Mar 7, 2026',
    author: 'Dr. Emily Chen',
    slug: 'liberal-arts-degree-careers'},
    {
    id: 'la2',
    title: 'Liberal Arts vs. STEM: The False Choice',
    excerpt:
      'Why the liberal arts vs. STEM debate misses the point. Learn how combining both creates the most adaptable, innovative professionals.',
    category: 'Liberal Arts',
    areaStudyId: 8,
    readTime: '6 min',
    date: 'Feb 24, 2026',
    author: 'Dr. Emily Chen',
    slug: 'liberal-arts-vs-stem'},
    {
    id: 'la3',
    title: 'Top Liberal Arts Colleges Offering Online Degrees',
    excerpt:
      'Prestigious liberal arts institutions are embracing online education. Discover which top-ranked schools now offer flexible degree options.',
    category: 'Liberal Arts',
    areaStudyId: 8,
    readTime: '5 min',
    date: 'Feb 10, 2026',
    author: 'Dr. Emily Chen',
    slug: 'top-liberal-arts-colleges-online'},
    {
    id: 'gs1',
    title: 'General Studies Degree: Is It Right for You?',
    excerpt:
      'A general studies degree offers maximum flexibility. Learn who benefits most from this customizable path and how to make it work for your career.',
    category: 'General',
    areaStudyId: 9,
    readTime: '6 min',
    date: 'Mar 6, 2026',
    author: 'Amanda Foster',
    slug: 'general-studies-degree-guide'},
    {
    id: 'gs2',
    title: 'How to Design Your Own Degree Program',
    excerpt:
      'Step-by-step strategies for creating a personalized general studies curriculum that aligns with your career goals and interests.',
    category: 'General',
    areaStudyId: 9,
    readTime: '7 min',
    date: 'Feb 19, 2026',
    author: 'Amanda Foster',
    slug: 'design-your-own-degree'},
    {
    id: 'gs3',
    title: 'Finishing Your Degree: Programs for Students With Credits',
    excerpt:
      'Already have college credits? Degree completion programs help you finish what you started with flexible, transfer-friendly options.',
    category: 'General',
    areaStudyId: 9,
    readTime: '5 min',
    date: 'Feb 8, 2026',
    author: 'Amanda Foster',
    slug: 'degree-completion-programs'},
    {
    id: 'mc1',
    title: 'Digital Marketing vs. Communications: Which Degree to Choose?',
    excerpt:
      'Both fields overlap, but key differences exist. Compare curriculum, career paths, and salary potential to make the right choice.',
    category: 'Media & Communications',
    areaStudyId: 11,
    readTime: '6 min',
    date: 'Mar 4, 2026',
    author: 'Jordan Lee',
    slug: 'digital-marketing-vs-communications'},
    {
    id: 'mc2',
    title: 'Breaking Into Public Relations: Skills Employers Want',
    excerpt:
      'PR is competitive. Learn which skills, experiences, and credentials will help you stand out and land your first role in the field.',
    category: 'Media & Communications',
    areaStudyId: 11,
    readTime: '7 min',
    date: 'Feb 26, 2026',
    author: 'Jordan Lee',
    slug: 'breaking-into-public-relations'},
    {
    id: 'mc3',
    title: 'Social Media Manager: How to Turn Likes Into a Career',
    excerpt:
      'Social media management is more than posting content. Discover what it takes to build a professional career in this growing field.',
    category: 'Media & Communications',
    areaStudyId: 11,
    readTime: '6 min',
    date: 'Feb 12, 2026',
    author: 'Jordan Lee',
    slug: 'social-media-manager-career'},
    {
            id: 'vd1',
            title: 'Graphic Design Degree Online: Building Your Portfolio Remotely',
            excerpt: '',
            category: 'Visual Arts & Graphic Design',
            areaStudyId: 12,
            readTime: '7 min',
            date: 'Mar 2, 2026',
            author: 'Sofia Ramirez',
            slug: 'graphic-design-portfolio-online'
        },
    {
    id: 'vd2',
    title: 'UX/UI Design: The Most In-Demand Design Specialization',
    excerpt:
      'User experience design is booming. Learn what UX/UI designers do, how much they earn, and how to break into this lucrative field.',
    category: 'Visual Arts & Graphic Design',
    areaStudyId: 12,
    readTime: '6 min',
    date: 'Feb 21, 2026',
    author: 'Sofia Ramirez',
    slug: 'ux-ui-design-career-guide'},
    {
    id: 'vd3',
    title: 'Freelance Designer or Agency Job: Which Path Is Right?',
    excerpt:
      'Weigh the pros and cons of freelancing versus working for a design agency, including income stability, creative freedom, and career growth.',
    category: 'Visual Arts & Graphic Design',
    areaStudyId: 12,
    readTime: '5 min',
    date: 'Feb 9, 2026',
    author: 'Sofia Ramirez',
    slug: 'freelance-vs-agency-designer'},
    {
    id: 'rs1',
    title: 'Online Theology Degrees: Preparing for Ministry Remotely',
    excerpt:
      'Can you earn a theology degree online and still be prepared for ministry? We examine program quality, accreditation, and practical training.',
    category: 'Religious Studies',
    areaStudyId: 13,
    readTime: '8 min',
    date: 'Feb 29, 2026',
    author: 'Rev. Thomas Wright',
    slug: 'online-theology-degrees'},
    {
    id: 'rs2',
    title: 'Careers in Religious Studies Beyond the Pulpit',
    excerpt:
      'Religious studies graduates work in education, counseling, non-profits, and more. Explore unexpected career paths for theology majors.',
    category: 'Religious Studies',
    areaStudyId: 13,
    readTime: '6 min',
    date: 'Feb 16, 2026',
    author: 'Rev. Thomas Wright',
    slug: 'religious-studies-careers'},
    {
    id: 'rs3',
    title: 'Chaplaincy Training: Bringing Faith to Healthcare and Military',
    excerpt:
      'Chaplains provide spiritual care in hospitals, prisons, and the military. Learn about the education, certification, and calling required.',
    category: 'Religious Studies',
    areaStudyId: 13,
    readTime: '7 min',
    date: 'Feb 7, 2026',
    author: 'Rev. Thomas Wright',
    slug: 'chaplaincy-training-guide'},
    {
    id: 'g1',
    title: 'How to Choose the Right Online College in 2026',
    excerpt:
      'With hundreds of accredited online programs available, finding the right fit can be overwhelming. Use this framework to narrow your search.',
    category: 'General',
    areaStudyId: 0,
    readTime: '8 min',
    date: 'Mar 20, 2026',
    author: 'Editorial Team',
    slug: 'choose-right-online-college'},
    {
    id: 'g2',
    title: 'Understanding College Accreditation: Why It Matters',
    excerpt:
      "Regional vs. national accreditation, programmatic accreditation, and why your degree's value depends on the institution's accreditation status.",
    category: 'General',
    areaStudyId: 0,
    readTime: '6 min',
    date: 'Mar 17, 2026',
    author: 'Editorial Team',
    slug: 'understanding-college-accreditation'},
    {
    id: 'g3',
    title: 'FAFSA 2026: Step-by-Step Application Guide',
    excerpt:
      "Don't leave money on the table. Our complete FAFSA walkthrough helps you maximize your financial aid for the upcoming academic year.",
    category: 'General',
    areaStudyId: 0,
    readTime: '10 min',
    date: 'Mar 3, 2026',
    author: 'Maria Gonzalez',
    slug: 'fafsa-2026-guide'},
    {
    id: 'g4',
    title: 'Online Learning Tips: How to Succeed as a Remote Student',
    excerpt:
      'Practical strategies for staying motivated, managing your time, and getting the most out of your online degree program.',
    category: 'General',
    areaStudyId: 0,
    readTime: '5 min',
    date: 'Feb 15, 2026',
    author: 'Editorial Team',
    slug: 'online-learning-tips'}
]